export const grupoOcupacionalesEnum = {
    I: 1,
    II: 2,
    III: 3,
    IV: 4,
    V: 5
}